/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import DefaultLineChart from "components/Charts/LineCharts/DefaultLineChart";
import GradientLineChart from "components/Charts/LineCharts/GradientLineChart";
import VerticalBarChart from "components/Charts/BarCharts/VerticalBarChart";
import HorizontalBarChart from "components/Charts/BarCharts/HorizontalBarChart";
import useDashboard from "./useDashboard";
import MDDatePicker from "../../components/MDDatePicker";
import Card from "@mui/material/Card";
import {CalendarToday} from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React from "react";

// Data

function Dashboard() {

  const {isLoading, dateRange, setDateRange, salesByProduct, feesOverTime, salesCountOverTime, newPatientsCount, patientsWhoPurchasedCount, patientsCount } = useDashboard();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {
          isLoading ?
              <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                     alignItems="center">
                  <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
              </MDBox> :
              <MDBox my={3}>
                <MDBox mb={1}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} sx={{ lineHeight: 0 }}>
                      <MDTypography variant="h5">Informes y estadísticas</MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
                  <MDBox sx={{display: 'flex', flexDirection: 'row'}} mb={2}>
                      <Card sx={{padding: 1, marginTop: 2, display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                          <CalendarToday sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                          <MDDatePicker
                              style={{ minWidth: '180px' }}
                              variant="standard"
                              value={`${dateRange[0]} to ${dateRange[1]}`}
                              onChange={date => {
                                  if(date.length === 2) {
                                      setDateRange([date[0].toISOString().slice(0, 10), date[1].toISOString().slice(0, 10)]);
                                  }
                              }}
                              options={{
                                  mode: 'range',
                                  dateFormat: 'Y-m-d',
                                  maxDate: new Date().toISOString().slice(0,10)
                              }}
                          />
                      </Card>
                  </MDBox>
                  <MDBox mb={3}>
                      <Grid container spacing={3}>
                          <Grid item xs={12} md={3}>
                              <Card sx={{padding: 2, marginTop: 2}}>
                                  <MDTypography variant="button" mb={0}>Pacientes Registrados</MDTypography>
                                  <MDTypography variant="h5">{patientsCount}</MDTypography>
                              </Card>
                          </Grid>
                          <Grid item xs={12} md={3}>
                              <Card sx={{padding: 2, marginTop: 2}}>
                                      <MDTypography variant="button" mb={0}>Pacientes Activos</MDTypography>
                                      <MDTypography variant="h5">{patientsWhoPurchasedCount}</MDTypography>
                              </Card>
                          </Grid>
                          <Grid item xs={12} md={3}>
                              <Card sx={{padding: 2, marginTop: 2}}>
                                  <MDTypography variant="button" mb={0}>Comisiones</MDTypography>
                                  <MDTypography variant="h5">${feesOverTime.total.toFixed(2)}</MDTypography>
                              </Card>
                          </Grid>
                          <Grid item xs={12} md={3}>
                              <Card sx={{padding: 2, marginTop: 2}}>
                                  <MDTypography variant="button" mb={0}>Pacientes Nuevos</MDTypography>
                                  <MDTypography variant="h5">{newPatientsCount}</MDTypography>
                              </Card>
                          </Grid>
                      </Grid>
                  </MDBox>

                  <MDBox mb={3}>
                      <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                              <DefaultLineChart
                                  title={`$${feesOverTime.total.toFixed(2)}`}
                                  description="Comisiones"
                                  chart={feesOverTime}
                              />
                          </Grid>
                          <Grid item xs={12} md={6}>
                              <DefaultLineChart
                                  title={`${salesCountOverTime.total}`}
                                  description="Pedidos (tickets)"
                                  chart={salesCountOverTime}
                              />
                          </Grid>
                          <Grid item xs={12} md={6}>
                              <HorizontalBarChart
                                  title="Ventas por producto"
                                  description="Productos"
                                  chart={salesByProduct}
                              />
                          </Grid>

                      </Grid>
                  </MDBox>
              </MDBox>
      }

      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
